export default __webpack_public_path__ + "static/media/IconOrderTags.096c05ad.svg";